import ReconnectingWebSocket, { Message } from 'reconnecting-websocket'
import store from '@/store'
import {Capacitor} from "@capacitor/core";

const SOCKET_STATE_CONNECTING = 0
const SOCKET_STATE_OPEN = 1
const SOCKET_STATE_CLOSING = 2
const SOCKET_STATE_CLOSED = 3

const PROTOCOL_HTTPS = 'https:'
const PROTOCOL_WS = 'ws:'
const PROTOCOL_WSS = 'wss:'

const CONDUCTOR_SOCKET_PATH = '/bet-composer/composer-ws/'

export class Socket {
  context!: string
  socket!: ReconnectingWebSocket

  constructor() {
    this.context = 'init'
    this.connect()

    if (Socket.context() != null || Socket.context() !== 'init') {
      this.reconnect()
    }
  }

  setContext(context: string): void {
    store.dispatch('setContext', context)
    this.context = context
  }

  connect(): void {
    // if (this.context === null) {
    // 	console.log("No context set");
    // 	return;
    // }

    this.initSocket()
  }

  reconnect(code?: number, reason?: string): void {
    if (Socket.context() === null || Socket.context() === 'init') {
      console.log('No context set')
      return
    }

    console.log(
      `Reconnecting to ${Socket.url()} - [${code ? code : 'N/A'}] ${
        reason ? reason : 'No reason given'
      }`,
    )
    this.socket.reconnect(code, reason)
  }

  contextRefresh(): void {
    this.reconnect(4000, 'Context changed, reconnecting to new url.')
  }

  send(data: Message): void {
    if (Socket.context() === null || Socket.context() === 'init') {
      console.log('No context set')
      return
    }

    this.socket.send(data)
  }

  private initSocket(): void {
    console.log('Initialising websocket')

    if (this.isConnected()) {
      console.log('Socket already initialised')
    } else if (this.isConnecting()) {
      console.log('Socket already initialising')
    } else {
      this.startSocket()
    }
  }

  isConnecting(): boolean {
    return this.socket && this.socket.readyState === SOCKET_STATE_CONNECTING
  }

  isConnected(): boolean {
    return this.socket && this.socket.readyState === SOCKET_STATE_OPEN
  }

  isClosing(): boolean {
    return this.socket && this.socket.readyState === SOCKET_STATE_CLOSING
  }

  isClosed(): boolean {
    return this.socket && this.socket.readyState === SOCKET_STATE_CLOSED
  }

  private startSocket(): void {
    console.log('Starting websocket')
    const options = {
      debug: true,
      startClosed: true,
			maxEnqueuedMessages: 1, // Default Infinity - do not want to use loads of memory or have gaps in audio.
			maxReconnectionDelay: 15000, // 
			maxRetries: 3000 // Don't run forever about 12 hours, max 15s, 4 a min, 12.5 hours but starts quicker.
    }
    this.socket = new ReconnectingWebSocket(Socket.url(), [], options)
		this.socket.addEventListener('close',  (event: CloseEvent) => {
			console.log("Websocket closed Code: " + event.code + " Reason: " + event.reason)
			if( event.code == 1003 ) {
				console.log('Access denied - redirect to home')
				const appRootUrl = store.getters['configModule/appRootUrl']
				console.log('Forcing logout')
				store.dispatch('accessControlModule/resetAccessControlStore')
				console.log('Reloading ' + appRootUrl)
				window.location.href = appRootUrl
			}
		})
  }

  private static url(): () => string {
    return () => {
      const protocol = Socket.protocol()
      const host = Socket.host()
      const context = Socket.context()
      const accessToken = Socket.accessToken()
      return (
        `${protocol}${host}${CONDUCTOR_SOCKET_PATH}${context}?access_token=` +
        accessToken
      )
    }
  }

  private static protocol(): string {
    return `${Socket.isSsl() ? PROTOCOL_WSS : PROTOCOL_WS}//`
  }

  private static isSsl(): boolean {
    return Capacitor.isNativePlatform() || window.location.protocol === PROTOCOL_HTTPS
  }

  private static host(): string {
    const stbHost = store.getters['configModule/stbApiHost']
    console.log('Websocket ' + stbHost)
    return stbHost
  }

  private static context(): string {
    const context = store.getters.context
    if (context === '') {
      console.log('Context is empty')
      return 'init'
    }
    return context
  }

  private static accessToken(): string {
    const accessToken = store.getters['configModule/authToken']
    if (!accessToken || accessToken === '') {
      console.log('Access token is empty')
    }
    return accessToken
  }
}

export const socket: Socket = new Socket()